export default __webpack_public_path__ + "static/media/NH_FI.2e3c8a7f.png";